import { useEffect, useState } from 'react';

import { useNotification } from '../../Contexts/NotificationContext';
import MonthlyAccesses from './MonthlyAccesses';
import TopContents from './TopContents';
import TotalAccesses from './TotalAccesses';

const ReportsList = ({ current }) => {
    const { setNotification } = useNotification();
    const [CNPJs, setCNPJs] = useState([]);
    const [users, setUsers] = useState([]);
    const [userLoading, setUserLoading] = useState(false);

    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    const fetchCnpjsAndUsers = async () => {
        if (userLoading) return;

        setUserLoading(true);

        try {
            const response = await fetch(`${baseUrl}/manager/cnpjs-usuarios`, {
                method: 'GET',
                headers: { Authorization: `Bearer ${accessToken}` },
            });

            if (!response.ok) throw new Error('Erro ao buscar os CNPJs e usuários.');

            const data = await response.json();

            setCNPJs(data.cnpjs);
            setUsers(data.usuarios);
        } catch (error) {
            setNotification({
                type: 'error',
                message: error.message,
                show: true,
            });
        } finally {
            setUserLoading(false);
        }
    };

    useEffect(() => {
        fetchCnpjsAndUsers();
    }, []);

    const renderChart = () => {
        switch (current) {
            case 'totalAccesses':
                return <TotalAccesses CNPJs={CNPJs} users={users} />;
            case 'monthlyAccesses':
                return <MonthlyAccesses CNPJs={CNPJs} users={users} />;
            case 'topContents':
                return <TopContents CNPJs={CNPJs} users={users} />;
            // case 'productContentAccesses':
            //     return <ProductContentAccesses CNPJs={CNPJs} users={users} />;
            default:
                return null;
        }
    };

    return <div className="rounded-sm border border-stroke bg-white px-5 pb-2.5 pt-6 shadow xl:pb-1">{renderChart()}</div>;
};

export default ReportsList;
